import { Country } from 'country-state-city';

import { Job } from '../../../fsm/jobs/jobs.fsm.types';

/**
 * The job's place of work. The country decides which work-authorisation questions Rio asks a candidate (the
 * job's country, never the candidate's), so a job saved without one is simply not asked: nothing is guessed.
 */
export const COUNTRY_OPTIONS = Country.getAllCountries().map((country) => ({
  value: country.isoCode,
  label: country.name,
}));

export interface LocationFormValues {
  address?: string | null;
  countryCode?: string | null;
  city?: string | null;
  state?: string | null;
}

const blankToNull = (value?: string | null): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

/**
 * Builds the `location` of a save from the form. A blank country, city or state is sent as null, which the
 * backend reads as "not provided" and leaves the stored value alone, so saving a job whose country was set
 * elsewhere cannot erase it. `base` is the job's existing location on edit.
 */
export const locationFromForm = (
  values: LocationFormValues,
  base?: Partial<Job['location']>,
): Job['location'] =>
  ({
    ...base,
    address: blankToNull(values.address),
    countryCode: blankToNull(values.countryCode),
    city: blankToNull(values.city),
    state: blankToNull(values.state),
  }) as unknown as Job['location'];
